import { ApiResponse } from "@/utils/ApiResponse";
import type { QueryKey } from "@tanstack/vue-query";
import { useQueryClient, useMutation } from "@tanstack/vue-query";
import { useToast } from "vue-toastification";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";
import { ToggleVisibilityProveedorction } from "../../actions/proveedorActions";

const toast = useToast();

type ToggleCtx = {
  previousEntries: [QueryKey, unknown][];
};

export function useProveedorToggleVisib() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (proveedorId: string) =>
      ToggleVisibilityProveedorction(proveedorId),

    onMutate: async (proveedorId: string): Promise<ToggleCtx> => {
      await queryClient.cancelQueries({ queryKey: ["ProveedoresList"] });
      const previousEntries = queryClient.getQueriesData({
        queryKey: ["ProveedoresList"],
      });

      queryClient.setQueriesData<ApiResponse<ProveedorInterface>>(
        { queryKey: ["ProveedoresList"] },
        (old) => {
          if (!old?.data?.data?.proveedores) return old;
          return {
            ...old,
            data: {
              ...old.data,
              data: {
                ...old.data.data,
                proveedores: old.data.data.proveedores.map((proveedor) =>
                  proveedor.id === proveedorId
                    ? {
                        ...proveedor,
                        isVisible: proveedor.isVisible === 1 ? 0 : 1,
                      }
                    : proveedor
                ),
              },
            },
          };
        }
      );

      return { previousEntries };
    },

    onError: (_error, _proveedorId, context) => {
      context?.previousEntries?.forEach(([queryKey, data]) => {
        queryClient.setQueryData(queryKey, data);
      });
      toast.error("No se pudo actualizar la visibilidad del proveedor.");
    },

    onSuccess: () => {
      toast.success("Visibilidad del proveedor actualizada.");
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["ProveedoresList"] });
    },
  });

  return {
    ...mutation,
  };
}
